import { render, staticRenderFns } from "./VerticalLabelsCard.vue?vue&type=template&id=92aa4c90&"
import script from "./VerticalLabelsCard.vue?vue&type=script&lang=js&"
export * from "./VerticalLabelsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports